import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MessageTypeConstants } from '../../../services/bot/Message';
import { processAndRemoveTab, setTabState } from '../../../state/actions/tabStack';
import { processSendMessage } from '../../../services/bot/conversation/SendMessage';
import { handleContainerTabChange, resetContainerFields } from '../../../state/actionsHelpers/tabStackActionsHelpers/message-type-container';
import { showTabCloseModal } from '../../../state/actions/modal';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';
import FMContainerComponent from './container';


const FMContainer = ({
  conversation,
  containerSelectedTabIndex = 0,
  selectedBreadcrumbTabId,
  options,
  message,
  messageType,
}) => {

  const [containerSelectedSubTabUpdatedIndex, setContainerSelectedSubTabIndex] = useState(0);
  const dispatch = useDispatch();

  //find current active breadcrumb index Or sub tabs active index 
  useEffect(() => {
    if (selectedBreadcrumbTabId && isArray(message) && message.length > 0) {
      const index = message.findIndex(
        (item) => item?.message?.options?.tabId === selectedBreadcrumbTabId
      );

      if (index !== -1) {
        setContainerSelectedSubTabIndex(index);
      }
    }
    else {
      setContainerSelectedSubTabIndex(containerSelectedTabIndex);
    }
  }, [selectedBreadcrumbTabId]);


  const getResponseContainer = () => {
    const responseContainer = [];

    message.forEach((tab) => {
      let responseTab = {};

      if (tab.type === MessageTypeConstants.MESSAGE_TYPE_FORM2) {
        let fieldsCopy = [];

        if (
          tab.message &&
          typeof tab.message.fields === 'object' &&
          Array.isArray(tab.message.fields.fields)
        ) {
          fieldsCopy = cloneDeep(tab.message.fields.fields);
        } else if (Array.isArray(tab.message.fields)) {
          fieldsCopy = cloneDeep(tab.message.fields);
        } else {
          console.warn("Expected tab.message.fields.fields to be an array, but got:", tab.message.fields);
        }

        fieldsCopy = fieldsCopy.map((col) => ({
          id: col.id,
          type: col.type,
          value: col.value,
          fileName: col.fileName,
        }));
        responseTab = {
          fields: fieldsCopy,
          formId: tab.message.options.formId,
        };
      } else if (tab.type === MessageTypeConstants.MESSAGE_TYPE_FORM) {
        const fieldsCopy = cloneDeep(tab.message.fields);
        responseTab = fieldsCopy;
      } else if (tab.type === MessageTypeConstants.MESSAGE_TYPE_TABLE) {
        let fieldsCopy = cloneDeep(tab.message.rows);
        fieldsCopy = fieldsCopy
          .filter((row) => !Object.values(row)[0].rowOptions.deleted)
          .map((row) => {
            const col = {};
            Object.values(row)[0].fields.map((field) => {
              if (field.type === 'file_field') {
                col[field.id] = {
                  value: field.value || null,
                  fileName: field.fileName || null,
                };
              } else {
                col[field.id] = field.value || null;
              }
              return field;
            });
            return col;
          });
        tab.message.rows.forEach(
          // eslint-disable-next-line no-prototype-builtins
          (row) => Object.values(row)[0].rowOptions.hasOwnProperty('deleted')
            && delete Object.values(row)[0].rowOptions.deleted,
        );
        responseTab = {
          rows: fieldsCopy,
          tableId: tab.message.options.tableId,
        };
      }

      responseContainer.push(responseTab);
    });
    return responseContainer;
  };


  const handleConfirm = (collectionData) => {
    const responseChat = {};

    responseChat.messageType = MessageTypeConstants.MESSAGE_TYPE_CONTAINER_RESPONSE;
    responseChat.message = {
      action: 'confirm',
      controlId: options.controlId,
      docId: options.docId,
      parentDocId: options.docId,
      tabId: options.tabId,
      container: getResponseContainer(),
      collectionData,
    };

    processSendMessage(responseChat);
    const updatedOptions = { ...options };
    updatedOptions.promptOnClose = false;

    if (options.allowClose && options.minimizeOnConfirm) {
      dispatch(setTabState(false))
      dispatch(processAndRemoveTab(conversation, { options }));
    }
  };


  const handleMoreItem = (button) => {
    const responseChat = {};
    responseChat.messageType = MessageTypeConstants.MESSAGE_TYPE_CONTAINER_RESPONSE;
    responseChat.message = {
      action: 'more',
      docId: options.docId,
      button,
      controlId: options.controlId,
      tabId: options.tabId,
      container: getResponseContainer(),
    };
    processSendMessage(responseChat);
  };

  const handleChangeTab = (event, newValue) => {
    const selectedItem = message[newValue];
    console.log('Selected Tab Item:', selectedItem);

    const childItemOptions = selectedItem?.message?.options;

    const responseChat = {
      messageType: MessageTypeConstants.MESSAGE_TYPE_CONTAINER_RESPONSE,
      message: {
        action: "tabSwitch",
        controlId: options?.controlId,
        tabId: options?.tabId,
        content: {
          selectedTab: childItemOptions?.controlId
        }
      },
    };

    processSendMessage(responseChat);
    dispatch(handleContainerTabChange(conversation, { options }, newValue));
    setContainerSelectedSubTabIndex(newValue);
  };

  const handleCancel = () => {
    if (options.promptOnClose === true) {
      dispatch(showTabCloseModal({ conversation, options, message, messageType }));
    } else {
      dispatch(resetContainerFields(conversation, { options }));
      dispatch(setTabState(false))
      dispatch(processAndRemoveTab(conversation, { options }));
    }
  };

  return (
    <FMContainerComponent
      conversation={conversation}
      options={options}
      message={message}
      messageType={messageType}
      parentTabId={options?.tabId}
      handleConfirm={handleConfirm}
      handleChangeTab={handleChangeTab}
      handleCancel={handleCancel}
      handleMoreItem={handleMoreItem}
      containerSelectedTabIndex={containerSelectedSubTabUpdatedIndex}
    />
  );
};

export default FMContainer;